import { LazyMotion } from 'motion/react';
import type { ReactNode } from 'react';

const loadFeatures = () => import('./motionFeatures').then((module) => module.default);

/**
 * Carrega as features de animação do `motion` fora do bundle inicial. Dentro dele, use `m.*`:
 * `motion.*` volta a embutir o bundle completo no chunk de quem importa.
 */
export function LazyMotionProvider({ children }: { children: ReactNode }) {
  return <LazyMotion features={loadFeatures}>{children}</LazyMotion>;
}
